import { useState, useEffect } from 'react';
import EditForm from '../../../utils/utilities/EditForm';

import { fields, initialValues, schema } from "./config";

const EditServiceCategory = ({dialog = false, st = 'service'}) => {

  const [initValues, setInitialValues] = useState(initialValues);

  useEffect(() => {
    setInitialValues({...initialValues, service_type: st});
  }, [st])

  return (
    <EditForm title={"Service Category"} initialValues={initValues} fields={fields} schema={schema} url={"services/service_categories"} dialog={dialog} ignore_id={dialog}>
      
     </EditForm>
  );
}

export default EditServiceCategory;